import Vue from 'vue'
import { Toast } from 'vant'
import { TOP_TOOLS, FUNCTION_TOOLS } from '@/tools/toolsConfig'

const ICON_BASE = 'https://rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/'
const ENTRY_ICONS = {
  tnm: TOP_TOOLS.find(t => t.routerPath && t.routerPath.includes('tnm'))?.smallIcon || `${ICON_BASE}XS4Ls4E8Vg199wRa.png`,
  cpg: TOP_TOOLS.find(t => t.routerPath && t.routerPath.includes('cpg'))?.smallIcon || `${ICON_BASE}g4ORSBQTEZGnz75a.png`,
  formula: `${ICON_BASE}AkRQti6VXliNm8gu.png`,
  scale: `${ICON_BASE}qaOotKfQNHTnlBBv.png`,
  cmm: FUNCTION_TOOLS.find(t => t.routerPath && t.routerPath.includes('cmm'))?.smallIcon || `${ICON_BASE}oaSQRJZ6rtnmlgpb.png`,
  da: FUNCTION_TOOLS.find(t => t.routerPath && t.routerPath.includes('da'))?.smallIcon || `${ICON_BASE}oaSQRJZ6rtnmlgpb.png`,
  trj: FUNCTION_TOOLS.find(t => t.routerPath && t.routerPath.includes('trj'))?.smallIcon || `${ICON_BASE}hILy47pk2N3wALP4.png`,
}

const PAGE_META = {
  tnm: {
    dataType: 1,
    fixedEntries: [
      { key: 'cpg', label: '临床指南', icon: ENTRY_ICONS.cpg, route: '/tools/cpg/list' },
      { key: 'cmm', label: '化疗手册', icon: ENTRY_ICONS.cmm, route: '/tools/cmm/home' },
      { key: 'da', label: '用药助手', icon: ENTRY_ICONS.da, route: '/tools/da/main' },
      { key: 'formula', label: '计算公式', icon: ENTRY_ICONS.formula, route: '/tools/formula/1' },
      { key: 'scale', label: '医学量表', icon: ENTRY_ICONS.scale, route: '/tools/formula/2' },
      { key: 'trj', label: '肿瘤研究', icon: ENTRY_ICONS.trj, route: '/tools/trj/list' },
    ],
  },
  cpg: {
    dataType: 5,
    fixedEntries: [
      { key: 'tnm', label: '肿瘤分期', icon: ENTRY_ICONS.tnm, route: '/tools/tnm/list' },
      { key: 'cmm', label: '化疗手册', icon: ENTRY_ICONS.cmm, route: '/tools/cmm/home' },
      { key: 'da', label: '用药助手', icon: ENTRY_ICONS.da, route: '/tools/da/main' },
      { key: 'formula', label: '计算公式', icon: ENTRY_ICONS.formula, route: '/tools/formula/1' },
      { key: 'scale', label: '医学量表', icon: ENTRY_ICONS.scale, route: '/tools/formula/2' },
      { key: 'trj', label: '肿瘤研究', icon: ENTRY_ICONS.trj, route: '/tools/trj/list' },
    ],
  },
  formula: {
    fixedEntries: [
      { key: 'scale', label: '医学量表', icon: ENTRY_ICONS.scale, route: '/tools/formula/2' },
      { key: 'cpg', label: '临床指南', icon: ENTRY_ICONS.cpg, route: '/tools/cpg/list' },
      { key: 'tnm', label: '肿瘤分期', icon: ENTRY_ICONS.tnm, route: '/tools/tnm/list' },
      { key: 'cmm', label: '化疗手册', icon: ENTRY_ICONS.cmm, route: '/tools/cmm/home' },
      { key: 'da', label: '用药助手', icon: ENTRY_ICONS.da, route: '/tools/da/main' },
      { key: 'trj', label: '肿瘤研究', icon: ENTRY_ICONS.trj, route: '/tools/trj/list' },
    ],
  },
  scale: {
    fixedEntries: [
      { key: 'formula', label: '计算公式', icon: ENTRY_ICONS.formula, route: '/tools/formula/1' },
      { key: 'cpg', label: '临床指南', icon: ENTRY_ICONS.cpg, route: '/tools/cpg/list' },
      { key: 'tnm', label: '肿瘤分期', icon: ENTRY_ICONS.tnm, route: '/tools/tnm/list' },
      { key: 'cmm', label: '化疗手册', icon: ENTRY_ICONS.cmm, route: '/tools/cmm/home' },
      { key: 'da', label: '用药助手', icon: ENTRY_ICONS.da, route: '/tools/da/main' },
      { key: 'trj', label: '肿瘤研究', icon: ENTRY_ICONS.trj, route: '/tools/trj/list' },
    ],
  },
}

const MATCH_ROUTE_MAP = {
  1: '/tools/tnm/list',
  2: '/tools/cmm/home',
  3: '/tools/formula/1',
  4: '/tools/formula/2',
  5: '/tools/cpg/list',
  6: '/tools/da/main',
}

function getApiUrl(path) {
  return `${String(Global_apiserver).replace(/\/$/, '')}/${path.replace(/^\//, '')}`
}

function isMiniProgram() {
  return window.__wxjs_environment === 'miniprogram'
}

function getMatchedList(res) {
  if (res && res.data && res.data.data && Array.isArray(res.data.data.list)) {
    return res.data.data.list
  }
  if (res && res.data && Array.isArray(res.data.list)) {
    return res.data.list
  }
  return []
}

export default function useFloatingBall({
  vm,
  toolType,
  detailId,
  matchKey,
  collectConfig = null,
  feedbackConfig = {},
}) {
  const meta = PAGE_META[toolType] || PAGE_META.formula
  const state = Vue.observable({
    toolPanelVisible: false,
    morePanelVisible: false,
    matchedItems: [],
    isCollected: false,
    loading: false,
  })

  const TOOL_NAME_MAP = {
    tnm: '肿瘤分期',
    cpg: '临床指南',
    formula: '计算公式',
    scale: '医学量表',
  }

  const DATA_TYPE_TOOL_NAME_MAP = {
    1: '肿瘤分期',
    2: '化疗手册',
    3: '计算公式',
    4: '医学量表',
    5: '临床指南',
    6: '用药助手',
  }

  function getToolName() {
    return TOOL_NAME_MAP[toolType] || toolType
  }

  function trackShow() {
    console.log('trackShow', getToolName())
    vm.$root.getSensorsTrackFunction('float_ball_show', { tool_name: getToolName() })
  }

  function trackClick() {
    vm.$root.getSensorsTrackFunction('float_ball_click', { tool_name: getToolName() })
  }

  function trackToolClick(targetName) {
    vm.$root.getSensorsTrackFunction('float_ball_tool_click', {
      source_tool: getToolName(),
      target_tool: targetName,
    })
  }

  function closePanels() {
    state.toolPanelVisible = false
    state.morePanelVisible = false
  }

  function toggleToolPanel() {
    state.toolPanelVisible = !state.toolPanelVisible
    if (state.toolPanelVisible) {
      state.morePanelVisible = false
      trackClick()
    }
  }

  function toggleMorePanel() {
    state.morePanelVisible = !state.morePanelVisible
    if (state.morePanelVisible) {
      state.toolPanelVisible = false
    }
  }

  async function fetchMatchedItems() {
    if (!meta.dataType || !detailId) {
      state.matchedItems = []
      return
    }
    // matchKey (firstCategoryId) is required for tnm/formula/scale, optional for cpg
    if (!matchKey && toolType !== 'cpg') {
      state.matchedItems = []
      return
    }

    state.loading = true
    try {
      const params = {
        dataType: meta.dataType,
        detailId,
      }
      if (matchKey) {
        params.firstCategoryId = matchKey
      }
      const res = await vm.$axios.post(getApiUrl('/medtools/jump/getToolsJump'), params)
      state.matchedItems = getMatchedList(res).slice(0, 10)
    } catch (error) {
      console.error('获取工具跳转信息失败:', error)
      state.matchedItems = []
    } finally {
      state.loading = false
    }
  }

  function getCollectionPayload(isToggle) {
    const payload = {
      head,
      type: collectConfig.type,
    }

    if (collectConfig.toolType !== undefined) {
      payload.toolType = collectConfig.toolType
    }
    if (collectConfig.relatedCode !== undefined) {
      payload.relatedCode = collectConfig.relatedCode
    }
    if (isToggle) {
      payload.isCollection = !state.isCollected
      if (collectConfig.headTitle !== undefined) {
        payload.headTitle = collectConfig.headTitle
      }
    }

    return payload
  }

  async function getCollectionStatus() {
    if (!collectConfig || !window.head.auth) return

    try {
      const res = await vm.$axios.post(getApiUrl('medtools/useRecord/getCollectionStatus'), getCollectionPayload(false))
      if (res.data && res.data.success) {
        state.isCollected = !!res.data.data
      }
    } catch (error) {
      console.error('获取收藏状态失败:', error)
    }
  }

  async function toggleCollect() {
    if (!collectConfig) return

    vm.$root.getSensorsTrackFunction('CollectClick', {
      position_type: collectConfig.trackPositionType,
      page_name: collectConfig.trackPageName,
    })

    if (!window.head.auth) {
      await doLoginCompatMiniPro()
      return
    }

    try {
      const res = await vm.$axios.post(getApiUrl('medtools/useRecord/collection'), getCollectionPayload(true))
      if (res.data && res.data.success) {
        state.isCollected = !state.isCollected
        Toast(state.isCollected ? '已收藏' : '已取消收藏')
      } else {
        Toast('操作失败，请重试')
      }
    } catch (error) {
      console.error('收藏操作失败:', error)
      Toast('操作失败，请重试')
    }
  }

  async function goFeedback() {
    if (typeof feedbackConfig.beforeFeedback === 'function') {
      feedbackConfig.beforeFeedback()
    }

    vm.$root.getSensorsTrackFunction('FeedBackClick', {
      position_type: feedbackConfig.trackPositionType,
      page_name: '工具意见反馈',
    })

    if (!window.head.auth) {
      await doLoginCompatMiniPro()
      return
    }

    const linkurl = feedbackConfig.linkurl || window.location.href
    const feedBackTitle = feedbackConfig.feedBackTitle || ''
    const documentDetailUrl = `${Global_root_path}?feedBackTitle=${encodeURIComponent(feedBackTitle)}&type=1&linkurl=${encodeURIComponent(linkurl)}#/NewFeedBack`
    const wxdocumentDetailUrl = `${Global_root_path}/?feedBackTitle=${encodeURIComponent(feedBackTitle)}&type=1&isWXpage=true&linkurl=${encodeURIComponent(linkurl)}#/NewFeedBack`

    if (is_app()) {
      nativefun('goToCommonWebPage', {
        param: {
          url: documentDetailUrl,
          needNotShowShareBtn: 1,
        },
      })
      return
    }

    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) === 'micromessenger') {
      if (self === top) {
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url: `/pages/CommonWebPage/index?loadUrl=${encodeURIComponent(wxdocumentDetailUrl)}&dologin=1&loginCancelType=1`,
            })
          } else {
            location.href = documentDetailUrl
          }
        })
      } else {
        location.href = documentDetailUrl
      }
      return
    }

    location.href = documentDetailUrl
  }

  function goAllTools() {
    closePanels()
    if (isMiniProgram() && typeof wx !== 'undefined' && wx.miniProgram) {
      wx.miniProgram.switchTab({
        url: '/pages/HomeTab/index',
        fail() {
          wx.miniProgram.reLaunch({ url: '/pages/HomeTab/index' })
        },
      })
      return
    }
    vm.$router.push('/tools/DoctorToolsIndex')
  }

  function goFixedTool(item) {
    closePanels()
    trackToolClick(item.label)
    if (item.key === 'formula' || item.key === 'scale') {
      localStorage.setItem('sourceData', '悬浮球')
    }
    vm.$router.push({
      path: item.route,
      query: { page_source: '悬浮球' },
    })
  }

  function goMatchedTool(item) {
    closePanels()
    const path = MATCH_ROUTE_MAP[item.dataType]
    if (!path) return

    const targetName = DATA_TYPE_TOOL_NAME_MAP[item.dataType] || ''
    trackToolClick(targetName)

    if (item.dataType === 3 || item.dataType === 4) {
      localStorage.setItem('sourceData', '悬浮球')
    }

    vm.$router.push({
      path,
      query: {
        firstCategoryId: item.firstCategoryId,
        secondCategoryId: item.secondCategoryId,
        page_source: '悬浮球',
      },
    })
  }

  function shouldShowAllTools() {
    return toolType === 'formula' || toolType === 'scale' || state.matchedItems.length > 0
  }

  return {
    state,
    meta,
    fixedEntries: meta.fixedEntries,
    fetchMatchedItems,
    getCollectionStatus,
    toggleToolPanel,
    toggleMorePanel,
    closePanels,
    toggleCollect,
    goFeedback,
    goAllTools,
    goFixedTool,
    goMatchedTool,
    shouldShowAllTools,
    trackShow,
  }
}
